import { type CalendarItemPayloadModel } from '@lichtblick/types';
import { formatName } from '@lichtblick/utils';

import { type CalendarEvent } from './type';

export const convertAppointmentToEvent = (appointments: CalendarItemPayloadModel[]): CalendarEvent[] => {
  return appointments?.map((appointment) => {
    const startDate = new Date(new Date(appointment.startAtUtc).toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
    const endDate = new Date(new Date(appointment.endAtUtc).toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));

    const adjustedEndDate =
      startDate.getTime() === endDate.getTime()
        ? new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 23, 59, 59, 999)
        : endDate;

    const baseEvent: CalendarEvent = {
      end: adjustedEndDate,
      id: appointment.id,
      start: startDate,
      name: '',
      type: '',
      teamName: appointment.teams?.[0]?.name ?? '',
    };

    if (appointment.__typename === 'AppointmentCalendarItemPayloadModel') {
      return {
        ...baseEvent,
        name: appointment.workOrder?.name ?? '',
        type: appointment.workflowDefinition?.name ?? '',
        isBinding: appointment.isBinding ?? false,
        isBlocker: false,
        workOrderId: appointment?.workOrder?.id,
      };
    }

    if (appointment.__typename === 'BlockerCalendarItemPayloadModel') {
      return {
        ...baseEvent,
        type: appointment.reason?.title ?? '',
        name: appointment.users?.[0] ? formatName(appointment.users?.[0]) : '',
        isBlocker: true,
      };
    }

    return baseEvent;
  });
};
